import { Image, Text } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';

const CarouselItem = ({ fields }) => {
  const defaultTarget = '#';
  const target = fields?.target?.value?.href ?? defaultTarget;

  return (
    <div className="vds-auto-layout__item" data-testid={fields.testid?.value}>
      <a
        className="vds-card vds-card--image-centre"
        href={target}
        rel="noopener noreferrer"
        target="_blank"
        data-testid={fields.testid?.value}
      >
        <div className="vds-card__inner">
          <div className="vds-card__logo" data-testid={`${fields.testid?.value}-logo`}>
            <Image field={fields.logo} />
          </div>

          <div className="vds-card__image" data-testid={`${fields.testid?.value}-image`}>
            <Image field={fields.partnerImage} />
          </div>

          <div className="vds-card__content" data-testid={`${fields.testid?.value}-content`}>
            <Text
              tag="h4"
              className="vds-card__heading"
              field={fields.title}
              data-testid={`${fields.testid?.value}-heading`}
            />
            <Text
              tag="p"
              field={fields.subtitle}
              data-testid={`${fields.testid?.value}-subtitle`}
            />
          </div>
        </div>
      </a>
    </div>
  );
};

export default CarouselItem;
